// extracted by mini-css-extract-plugin
export default {"search":"SideMain_search__hJcxM","add":"SideMain_add__eNpIl","chats":"SideMain_chats__GaWa6"};